// extracted by mini-css-extract-plugin
export default {"hipaaBanner":"hipaaBanner_hipaaBanner__J9dP1"};